import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ApiService, PaymentV2Service, UtilService, VariablesService, VwoService } from '../../shared/services';
import { IPaymentSipConfig } from '../payment-sip/payment-sip.model';

@Component({
  selector: 'app-payment-sip-upi',
  templateUrl: './payment-sip-upi.component.html',
  styleUrls: ['./payment-sip-upi.component.scss']
})
export class PaymentSipUpiComponent implements OnInit, OnChanges {

  @Input() config: IPaymentSipConfig;
  @Input() showTime = true;
  @Output() dataEmit = new EventEmitter();

  upiForm = new FormGroup({
    upi: new FormControl('', [Validators.required, Validators.pattern(/^\w.+@(upi|paytm|ybl|axl|ibl|apl|okhdfcbank|okaxis|okicici|oksbi)+$/i)])
  });
  upiOptions = ['paytm', 'upi', 'ybl', 'axl', 'ibl', 'apl', 'okhdfcbank', 'okaxis', 'okicici', 'oksbi'];
  filteredOptions: Observable<string[]>;
  isLoading;
  verified;
  checkForValidUpiId = true;

  constructor(
    private api: ApiService,
    public util: UtilService,
    public vars: VariablesService,
    public paymentV2: PaymentV2Service,
    public vwo: VwoService
  ) { }

  ngOnChanges() {
    this.fillUpiId(this.config);
    if (this.config.one_time_donation) {
      this.upiForm.get('upi').clearValidators();
      this.upiForm.get('upi').addValidators([Validators.required, Validators.pattern(/^\w.+@\w+$/)]);
    }
  }

  ngOnInit() {
    this.submitForm();
    // this.paymentV2.paymentConfig.subscribe((config) => this.fillUpiId(config));
    this.filteredOptions = this.upiForm.get('upi').valueChanges.pipe(
      startWith(''),
      map(value => this.upiOptions.filter(option => option.includes(value.toLowerCase().split('@')[1])))
    );
  }

  submitForm() {
    this.paymentV2.pledgeBtn.subscribe(tab => {
      if (tab === 'upi') {
        if (this.upiForm.valid && this.verified) {
          const emitPayload = {
            mode: this.config.selectedTab.order_mode,
            mode_value: 'VPA',
            VPA: this.upiForm.get('upi').value,
            origin_vpa: 'payment_form'
          };
          if (this.vwo.razorpay_upi_sip_AB()) {
            emitPayload['payment_gateway'] = 'razorpay_emandate';
          }
          if (this.vwo.phonepe_recurring_AB() && this.config.sip_wallet !== 1) {
            emitPayload['payment_gateway'] = 'phonepe_recurring';
          }
          this.dataEmit.emit(emitPayload);
        } else {
          this.util.checkValidForm(this.upiForm);
        }
      }
    });
  }

  async fillUpiId(config) {
    if (!this.upiForm.get('upi').value) {
      if (config.lastOrder && config.lastOrder.upi_id) {
        this.upiForm.get('upi').setValue(config.lastOrder.upi_id);
        this.verified = true;
      } else if (this.config?.paymentOptions?.options?.RECOMMENDED_VPA) {
        this.upiForm.get('upi').setValue(this.config?.paymentOptions?.options?.RECOMMENDED_VPA);
        this.verified = true;
      } else if (config.user?.phone_1 && this.checkForValidUpiId) {
        for (const item of ['@ybl', '@paytm', '@upi', '@apl']) {
          this.checkForValidUpiId = false;
          const phoneNumber = config.user?.phone_1?.replace(/^0+/, '') + item;
          const isVerified = await this.verifyUpi(phoneNumber);
          if (isVerified) {
            this.upiForm.get('upi').setValue(phoneNumber);
            return isVerified;
          }
        }
      }
    }
  }

  verifyUpi(value): Promise<boolean> {
    return new Promise((resolve, reject) => {
      try {
        this.isLoading = true;
        this.api.post(environment.APP.API_URLS.VPA_VALIDATION, { vpa: value }, false).subscribe((res) => {
          this.isLoading = false;
          this.verified = res.data && res.data.isVPAValid ? true : false;
          this.upiForm.controls.upi.setErrors({ invalid: this.verified ? null : true });
          if (this.verified) {
            this.upiForm.controls.upi.updateValueAndValidity();
          }
          resolve(this.verified);
        });
      } catch (error) {
        reject(false);
      }
    });
  }

  @HostListener('blur', [])
  onInputBlur() {
    if (!this.verified && this.upiForm.get('upi').valid) {
      this.verifyUpi(this.upiForm.get('upi').value);
    }
  }

}
